/**
 * Утилита для скачивания/открытия файлов (HttpOnly cookie session).
 */

/**
 * Извлекает имя файла из file_url
 * Поддерживает форматы: /api/uploads/filename.ext, filename.ext, полные URL
 */
export function extractFileNameFromUrl(fileUrl: string): string {
  if (!fileUrl) return ''
  
  // Если это полный URL, извлекаем путь
  try {
    const url = new URL(fileUrl)
    fileUrl = url.pathname
  } catch {
    // Не URL, используем как есть
  }
  
  // Убираем начальный слэш и путь
  const parts = fileUrl.split('/')
  const fileName = parts[parts.length - 1]
  
  return fileName || fileUrl
}

/**
 * Bezpečná URL pro otevření přílohy (cookie/Bearer přes /api/download).
 */
export function protectedFileHref(fileUrl: string | undefined | null): string {
  if (!fileUrl) return '#'
  const trimmed = fileUrl.trim()
  if (!trimmed) return '#'
  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const url = new URL(trimmed)
      if (url.pathname.includes('/api/uploads/') || url.pathname.includes('/api/download')) {
        const fileName = extractFileNameFromUrl(trimmed)
        return fileName ? `/api/download?file=${encodeURIComponent(fileName)}` : '#'
      }
      return trimmed
    } catch {
      return trimmed
    }
  }
  const fileName = extractFileNameFromUrl(trimmed)
  return fileName ? `/api/download?file=${encodeURIComponent(fileName)}` : '#'
}

/**
 * Скачать или открыть файл из тикета/заявки
 */
export async function downloadFile(
  fileName: string,
  ticketId?: string,
  requestId?: string,
  download: boolean = false
): Promise<void> {
  const actualFileName = extractFileNameFromUrl(fileName)
  
  const params = new URLSearchParams({
    file: actualFileName,
  })

  if (ticketId) {
    params.append('ticket_id', ticketId)
  }
  if (requestId) {
    params.append('request_id', requestId)
  }
  if (download) {
    params.append('download', '1')
  }

  const url = `/api/download?${params.toString()}`

  try {
    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include',
    })

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Unauthorized')
      }
      if (response.status === 404) {
        throw new Error('File not found')
      }
      throw new Error(`HTTP ${response.status}`)
    }

    // Получаем blob
    const blob = await response.blob()
    
    // Создаем URL для blob
    const blobUrl = window.URL.createObjectURL(blob)
    
    // Создаем временную ссылку для скачивания/открытия
    const link = document.createElement('a')
    link.href = blobUrl
    link.target = '_blank'
    
    if (download) {
      link.download = actualFileName
    }
    
    // Добавляем в DOM, кликаем и удаляем
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    
    // Освобождаем память
    setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100)
  } catch (error) {
    console.error('Error downloading file:', error)
    throw error
  }
}

